module.exports = __webpack_public_path__ + "static/media/icon_construccion.6f9ba288.svg";